import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NotFoundPage from "./pages/not-found/NotFound";
import Login from "./pages/login/Login";
import Students from "./pages/students/students";
import Overview from "./pages/overview/overview";

import StudentDetail from "./pages/student-detail/StudentDetail";
import PayoutDashboard from "./pages/payout-dashboard/PayoutDashboard";
import RegularPayoutTable from "./pages/payout/regular";
import PayoutHistoryTable from "./pages/payout/history";
import EmergencyPayoutTable from "./pages/payout/emergency";
import Review from "./pages/reviews";
import LanguageToTeachTable from "./pages/reviews/language-teach/LanguageTable";
import LanguageToTeachDetails from "./pages/reviews/language-teach/details";
import WorkExperienceTable from "./pages/reviews/work-experience/work.table";
import WorkExperienceDetail from "./pages/reviews/work-experience/details";
import LanguageSpokenDetail from "./pages/reviews/language-speaker/details";
import LanguageToSpeakTable from "./pages/reviews/language-speaker/speaker.table";
import IntroductoryDetails from "./pages/reviews/introductory/details";
import IntroductoryTable from "./pages/reviews/introductory/introductory.table";
import CerticationTable from "./pages/reviews/certification/certification.table";
import CertificationDetails from "./pages/reviews/certification/details";
import EducationTable from "./pages/reviews/education/education.table";
import EductionDetails from "./pages/reviews/education/details";
import PartnerDashboard from "./pages/partners/partner.dashboard";
import PartnerTable from "./pages/partners/partner.list";
import PartnerDetails from "./pages/partners/partner.details";
import Logout from "./pages/logout/logout";
import AdminDashboardPage from "./pages/admin/admin.dashboard";
import AdminListTablePage from "./pages/admin/list.admin";
import ShowAdminDetailsPage from "./pages/admin/admin.details";
import StudentReportList from "./pages/report/StudentReportList";
import AdminEmailComposer from "./pages/emails/AdminEmailComposer";
import OtpLogin from "./pages/login/otp_login";
import ForbiddenPage from "./pages/error/forbidden_page";
import Teachers from "./pages/teachers/teachers";
import TeachersTable from "./pages/teachers-table/TeachersTable";
import TeachersDetails from "./pages/teachers-detail/TeacherDetail";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/otp-verification" element={<OtpLogin />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Overview />} />
        <Route path="/students" element={<Students />} />
        <Route path="/students/:studentId" element={<StudentDetail />} />
        <Route path="/report/list" element={<StudentReportList />} />
        <Route path="/payout/dashboard" element={<PayoutDashboard />} />

        <Route path="/regular-payout/list" element={<RegularPayoutTable />} />
        <Route path="/payout-history/list" element={<PayoutHistoryTable />} />
        <Route path="/emergency-payouts" element={<EmergencyPayoutTable />} />

        <Route path="/teachers/dashboard" element={<Teachers />} />
        <Route path="/teachers/list" element={<TeachersTable />} />
        <Route
          path="/teachers/:teacherId/details"
          element={<TeachersDetails />}
        />

        <Route path="/review" element={<Review />} />
        <Route
          path="/review/language-to-teach/list"
          element={<LanguageToTeachTable />}
        />

        <Route
          path="/review/language-to-teach/:requestId/details"
          element={<LanguageToTeachDetails />}
        />

        <Route
          path="/review/work-experience/list"
          element={<WorkExperienceTable />}
        />
        <Route
          path="/review/work-experience/:requestId/details"
          element={<WorkExperienceDetail />}
        />

        <Route
          path="/review/language-to-teach/list"
          element={<LanguageToTeachTable />}
        />
        <Route
          path="/review/language-to-teach/:requestId/details"
          element={<LanguageToTeachTable />}
        />

        <Route
          path="/review/language-spoken/list"
          element={<LanguageToSpeakTable />}
        />
        <Route
          path="/review/language-spoken/:requestId/details"
          element={<LanguageSpokenDetail />}
        />

        <Route
          path="/review/certification/list"
          element={<CerticationTable />}
        />
        <Route
          path="/review/certification/:requestId/details"
          element={<CertificationDetails />}
        />

        <Route
          path="/review/introductory/list"
          element={<IntroductoryTable />}
        />
        <Route
          path="/review/introductory/:requestId/details"
          element={<IntroductoryDetails />}
        />

        <Route path="/review/education/list" element={<EducationTable />} />
        <Route
          path="/review/education/:requestId/details"
          element={<EductionDetails />}
        />

        <Route path="/partners/dashboard" element={<PartnerDashboard />} />
        <Route path="/partners/list" element={<PartnerTable />} />
        <Route
          path="/partners/:requestId/details"
          element={<PartnerDetails />}
        />

        <Route
          path="/review/education/:requestId/details"
          element={<EductionDetails />}
        />

        <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
        <Route path="/admin/list" element={<AdminListTablePage />} />
        <Route
          path="/admins/:requestId/details"
          element={<ShowAdminDetailsPage />}
        />
        <Route path="/email/compose" element={<AdminEmailComposer />} />

        <Route path="/logout" element={<Logout />} />
        <Route path="/forbidden" element={<ForbiddenPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

export default App;
